import { rage, useObservable } from '~/rage';
import ServeIndex from './views/ServeIndex';

const Layout = () => {
	const visibleLayouts = useObservable(rage.gui.getVisibleLayouts());

	if (visibleLayouts.length === 0 && rage.config.isStub()) {
		return <ServeIndex />;
	} else {
		return null;
	}
};

export default Layout;
